import type React from 'react';
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className={`font-heading text-xl md:text-2xl font-bold transition-colors duration-500 ${
              isScrolled ? 'text-foreground-950' : 'text-white'
            }`}>
              友田真希
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap ${
                location.pathname === '/'
                  ? isScrolled
                    ? 'bg-primary-500 text-white'
                    : 'bg-white/20 text-white backdrop-blur-sm'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/latest"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? isScrolled
                    ? 'bg-primary-500 text-white'
                    : 'bg-white/20 text-white backdrop-blur-sm'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              动态资讯
            </Link>
            <Link
              to="/category/works"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap ${
                location.pathname === '/category/works'
                  ? isScrolled
                    ? 'bg-primary-500 text-white'
                    : 'bg-white/20 text-white backdrop-blur-sm'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              作品集锦
            </Link>
            <Link
              to="/category/photo"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap ${
                location.pathname === '/category/photo'
                  ? isScrolled
                    ? 'bg-primary-500 text-white'
                    : 'bg-white/20 text-white backdrop-blur-sm'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              写真集
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap ${
                location.pathname === '/about'
                  ? isScrolled
                    ? 'bg-primary-500 text-white'
                    : 'bg-white/20 text-white backdrop-blur-sm'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              关于
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden flex items-center justify-center w-10 h-10 rounded-full transition-colors ${
              isScrolled ? 'text-foreground-950 hover:bg-background-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}